import { gql, useMutation } from '@apollo/client'
import {
  MutationRentalCommentCreateArgs,
  MutationRentalCommentCreatePayload,
} from 'src/generated'

const MUTATION_RENTAL_COMMENT_CREATE = gql`
  mutation RentalCommentCreate($input: MutationRentalCommentCreateInput!) {
    rentalCommentCreate(input: $input) {
      rentalComment {
        id
      }
    }
  }
`

const useRentalCommentCreateMutation = () => {
  return useMutation<
    { rentalCommentCreate: MutationRentalCommentCreatePayload },
    MutationRentalCommentCreateArgs
  >(MUTATION_RENTAL_COMMENT_CREATE)
}

export default useRentalCommentCreateMutation
